import { createConfig, configureChains } from 'wagmi'
import { polygon } from 'wagmi/chains'
import type { ConfigCtrlState } from '@web3modal/core'

import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'

import APP_CONFIG from 'primsell-shared-layer/core/config'

export class WalletconnectService {
  config
  modalConfig
  connector

  constructor() {
    if (!process.env.REACT_APP_WALLET_CONNECT_PUBLIC_PROJECT_ID) {
      return
    }
    const projectId = process.env.REACT_APP_WALLET_CONNECT_PUBLIC_PROJECT_ID || ''
    const apiKey = process.env.REACT_APP_ALCHEMY_PROJECT_ID
    if (!apiKey && !projectId) {
      throw new Error('You need to provide REACT_KEY(s) env variable')
    }

    const chains = [polygon]

    const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
    const connectorWalletConnect = w3mConnectors({
      projectId,
      chains,
    })
    this.connector = connectorWalletConnect

    this.config = createConfig({
      autoConnect: false,
      connectors: connectorWalletConnect,
      publicClient,
    })

    this.modalConfig = {
      projectId,
      ethereumClient: new EthereumClient(this.config, chains),
      explorerRecommendedWalletIds: APP_CONFIG.explorerRecommendedWalletIds,
      explorerExcludedWalletIds: 'ALL' as ConfigCtrlState['explorerExcludedWalletIds'],
    }
  }
}
